<template>

    <div class="modal fade" :id="`modalPersona${persona.clienteId != undefined ? persona.clienteId : persona.personaFisicaId}`" tabindex="-1" aria-labelledby="modalIngresos" aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered modal-xl"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalIngresos">
                        Detalle Ingresos: {{ $filters.CapitalizeFilter(persona.nombre) }}
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div id="modalDesktop" class="modal-body">
                    <table class="table table-striped table-hover" v-if="persona.ingresos != null">
                        <thead>
                            <tr>
                                <th scope="col">Monto</th>
                                <th scope="col">Empresa</th>
                                <th scope="col">Tipo de ingreso</th>
                                <th scope="col">Comprobante de Ingreso</th>
                                <th scope="col">Puesto</th>
                                <th scope="col">Giro de la empresa</th>
                                <th scope="col">Antigüedad</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ingreso,index) in ingresos" :key="index">
                                <td>{{ $filters.MoneyFilter(ingreso.montoIngreso) }}</td>
                                <td>{{ ingreso.empresa }}</td>
                                <td>{{ ingreso.tipoIngreso }}</td>
                                <td>{{ ingreso.comprobantes }}</td>
                                <td>{{ ingreso.puesto }}</td>
                                <td>{{ ingreso.giroEmpresa }}</td>
                                <td>{{ ingreso.antiguedadAnio }} años y {{ ingreso.antiguedadMes }} meses</td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else>
                        Sin ingresos registrados
                    </div> 
                </div>
                <div id="modalMovil" class="modal-body">
                    <div v-if="persona.ingresos != null">
                        <div
                            class="
                                card card-body
                                mb-3
                                texto
                            "
                            v-for="(ingreso,index) in ingresos" :key="index"
                        >
                            <h5 class="card-title">Ingreso: {{ index+1 }}</h5>
                            <hr>
                            <div class="row mb-3">
                                <div class="col-sm-5 col-md-4">Monto: </div>
                                <div class="col-sm-7 col-md-8">{{ $filters.MoneyFilter(ingreso.montoIngreso) }}</div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-5 col-md-4">Empresa: </div>
                                <div class="col-sm-7 col-md-8">{{ ingreso.empresa }}</div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-5 col-md-4">Tipo de ingreso: </div>
                                <div class="col-sm-7 col-md-8">{{ ingreso.tipoIngreso }}</div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-5 col-md-4">Comprobante de Ingreso: </div>
                                <div class="col-sm-7 col-md-8">{{ ingreso.comprobantes }}</div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-5 col-md-4">Puesto: </div>
                                <div class="col-sm-7 col-md-8">{{ ingreso.puesto }}</div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-5 col-md-4">Giro de la empresa: </div>
                                <div class="col-sm-7 col-md-8">{{ ingreso.giroEmpresa }}</div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-5 col-md-4">Antigüedad: </div>
                                <div class="col-sm-7 col-md-8">{{ ingreso.antiguedadAnio }} años y {{ ingreso.antiguedadMes }} meses</div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        Sin ingresos registrados
                    </div> 
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
    name: 'ModalDetalleIngresos',

    props: {
        persona: {}
    },

    data () {
        return {
            ingresos: []
        }
    },
    
    mounted() { 
        this.ingresos = (this.persona.ingresos != null && this.persona.ingresos != undefined) ? this.persona.ingresos : ""
    }
})
</script>

<style scoped>
    
    .texto {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 21px;
        color: #302d74;
    }

    @media (min-width: 1025px) {
        #modalDesktop {
            display: block;
        }

        #modalMovil {
            display: none;
        }
    }

    @media (max-width: 1025px) {
        #modalDesktop {
            display: none;
        }

        #modalMovil {
            display: block;
        }
    }

</style>